import { render, staticRenderFns } from "./product-selection.vue?vue&type=template&id=4a69ef44"
import script from "./product-selection.vue?vue&type=script&lang=ts"
export * from "./product-selection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports